<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <main class="main-wrapper flex-grow-1">
      <div class="container container--narrow pdt-50">
        <div class="t-headline10 font-b t-line-h-30">
          {{ $t('1912') }}
        </div>
        <div class="t-body1 mgt-6 fornt-r t-color-bodyGrayA mgt-8">
          {{ $t('1913') }}
          <!-- 프로필로 사용할 패턴을 설정하세요. -->
        </div>
        <div class="mgt-24">
          <div v-if="profileData" class="profile-wrap square-image">
            <img v-if="!cropperVisible"
                 :src="profileData.file.resourceUri ? profileData.file.resourceUri : require('@/images/thumnail.png')"
                 alt=""
                 class="w-full cursor-pointer" tabindex="0"
                 @click="showFileChooser()" @keypress="showFileChooser()"
            >
            <vue-cropper
                v-if="cropperVisible"
                ref="cropper"
                :autoCropArea="1"
                :cropmove="cropImage"
                :src="cropImg"
                alt="Source Image"
                class="cropper"
            >
            </vue-cropper>
          </div>

          <input
              ref="input"
              :accept="allowImgExt()"
              class="d-none"
              name="image"
              type="file"
              @change="setImage"
          />
          <div class="mgt-50 mgb-50">
            <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8"
                    tabindex="0" @click="saveImage()" @keypress="saveImage()">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r"> {{ $t('281') }}</span>
            </button>
            <button class="mdc-button bg-white t-color-secondaryBtnText b-radius4" tabindex="0" @click="goBack()" @keypress="goBack()">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">{{ $t('5') }}</span>
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>

</template>

<script>
/**
 * 멤버십 - 프로필 이미지 변경 컴포넌트(membership - change profile image component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService.js'
import memberApi from '@/api/memberApi.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

import {MDCRipple} from '@material/ripple'
import {fileMixin} from "@/mixins/file";

import snackMessage from "@/plugins/snackMessage";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  components: {
    VueCropper,
    TopAppBarDrawer
  },

  mixins: [fileMixin],

  data() {
    return {
      profileData: null,
      cropImg: '',
      cropperVisible: false,
    }
  },

  mounted() {
    this.fatchData()
    this.setMaterialUi()
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 프로필 정보 가져오기(get profile information)
    fatchData() {
      this.cropImg = ''
      this.cropperVisible = false

      memberApi.getProileImage().then((response) => {
        this.profileData = response.data.data
      })
    },

    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },

    showFileChooser() {
      this.$refs.input.click();
    },

    setImage(e) {
      this.cropperVisible = true
      const file = e.target.files[0];

      if (this.getType(file.type) === 'video') {
        snackMessage(this.$t("3462"));
        this.cropperVisible = false;
        return;
      }
      this.mediaTypeValidCheck(file, 'IMAGE');

      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        console.log('Sorry, FileReader API not supported');
      }
    },

    // 이미지 업로드 및 프로필 저장
    saveImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // let canvasData = this.elemCanvas.toDataURL("image/png");
      let blob = this.dataURItoBlob(this.cropImg);

      let formData = new FormData()
      formData.append('file', blob, 'profile.png')

      httpService.upload(formData).then((response) => {
        let params = {
          file: response.data.data[0],
          backgroundColor: '',
          defaultColor: '',
          pattenColor: '',
          pattenValue: [],
        }

        memberApi.uploadProileImage(params).then((response) => {
          this.fatchData()
          snackMessage(this.$t("3329"));
        })
      }).catch((err) => {
        console.log('FAILURE!!', err);
      });
    },

    // 캔버스 이미지 전송위한 Blob 함수(Blob function for canvas image transfer)
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      let byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }

      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type: mimeString});
    },
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  }
}
</script>